module.exports = __webpack_public_path__ + "img/M007-09_jrb-04.aecf5c76.jpg";